<template>

  <div>

    <!-- Record Images -->
    <div v-if="hasImages" class="mt-8 mr-8" style="min-width:150px;max-width:200px;">
      <ImageSlider :images="data.record.images" imageClass="h-24" />
    </div>

    <!-- Title -->
    <p v-if="data.title_markdown" class="whitespace-pre-wrap">{{ data.title_markdown.markdown }}</p>
    <!-- <h2 v-else-if="data.title" class="py-1 mb-4 inline-block">{{ data.title }}</h2> -->
    <h1 v-else-if="data.title" class="py-8 mb-4">{{ data.title }}</h1>

    <!-- Body -->
    <p v-if="data.body_markdown" v-html="data.body_markdown.html" class="whitespace-pre-wrap"></p>
    <p v-else-if="data.body" v-html="data.body" class="whitespace-pre-wrap"></p>

    <div class="divider-border"></div>

    <!-- Add to Project -->
    <button v-if="recordHasAlreadyBeenAdded" type="button" class="text-white cursor-default uppercase inline-block" style="outline:none;position:relative;top:-3px;line-height:20px;letter-spacing:2px;opacity:.87;font-family:Jura;font-weight:600;font-size:12px;background-color:#004f45;padding:4px 33px;margin:0 4px 4px 0;"><span>Added</span><i class="fa fa-check"></i></button>
    <VaAnswerButton v-else
      :linkClass="'small has-icon'"
      :showIcon="true"
      :answer="data"
      :action="data.action || {}"
      :text="data.text || 'ADD TO PROJECT'"
      @applyAction="applyAction"
    />

    <div class="divider-border"></div>

    <!-- Factors (accordion) -->
    <template v-if="hasFactors">
      <h3 class="mt-16 mb-4">Product Specs</h3>
      <VaRecordAccordion :factors="data.record.factors"></VaRecordAccordion>
    </template>

    <!-- Docs (accordion) -->
    <template v-if="hasDocs">
      <h3 class="mt-16 mb-4">Support Docs</h3>
      <SupportAccordion :docs="data.docs"></SupportAccordion>
    </template>

  </div>

</template>

<script>

import { mapActions } from 'vuex'

import ImageSlider from '@/components/ImageSlider.vue'
import VaAnswerButton from '@/components/VaAnswerButton.vue'
import VaRecordAccordion from '@/components/VaRecordAccordion.vue'
import SupportAccordion from '@/components/SupportAccordion.vue'

export default {

  name: 'VaRecord',

  components: {
    VaAnswerButton,
    VaRecordAccordion,
    ImageSlider,
    SupportAccordion
  },

  props: {

    data: { type: Object, default: {} }

  },

  computed: {

    hasImages () {

      return (this.data && this.data.record && this.data.record.images && this.data.record.images.length) ? true : false;

    },

    hasFactors () {

      return (this.data && this.data.record && this.data.record.factors && this.data.record.factors.length) ? true : false;

    },

    hasDocs () {

      return (this.data && this.data.docs) ? true : false;

    },

    recordHasAlreadyBeenAdded () {

      return (this.data && this.data.record && this.data.record.already_added) ? true : false;

    }

  },

  methods: {

    ...mapActions(['applyAction'])

  }

}
</script>
